<div class="user-info">

  <div class="info">
    <div>
      <div class="name">Hi, {{user?.full_name?.split(' ')[0]}}</div>
      <div class="email">{{user?.email}}</div>
    </div>
    <button *ngIf="!vars.isAgent" (click)="onClickEdit()" mat-icon-button>
      <mat-icon class="edit-icon">edit</mat-icon>
    </button>
  </div>
  <mat-checkbox *ngIf="!payment_config?.is_sip" class="anonymous-check" [(ngModel)]="isAnonymous" (change)="isAnonymousChange.emit(isAnonymous)" color="primary">
    {{'Stories.donations.donationAnonymous' | translatePipe | async}}
  </mat-checkbox>
  <div class="quickdonate-wrapper" *ngIf="user && vwo.repeatorder_ministoryAB() && params?.mini_story === '1'">
    <app-quicdonate_carousel></app-quicdonate_carousel>
  </div>
  <div *ngIf="!(vars.pageName === 'mini_story' && vars.showBulkDonationForMiniStory.test(params?.utm_source))" class="text-center proceed-btn">
    <app-donate-btn id="formSubmit" class="app-button" [btnClass]="'contri-initiate-btn donation-form-submit'" type="submit"
                    [label]="config.donate_label | translatePipe | async" [isOrderLoading]="isLoading || paymentV2.isOrderLoading ? true : false" [amount]="amount"
                    [type]="paymentUtilService.paymentMode" [isSipCause]="isSipCause" (onClickListner)="onSubmit()" [payment_config]="payment_config">
    </app-donate-btn>
  </div>

  <div *ngIf="vars.pageName === 'mini_story' && vars.showBulkDonationForMiniStory.test(params?.utm_source)" class="bulk-selection">
    <app-bulk-donation-selection-v2
      [amount]="amount"
      [campaign_id]="campaignId"
      [currency]="currency"
      [disabled]="disabled"
      [isOrderLoading]="isLoading"
      (onSubmit)="submitBulk($event)"
    />
  </div>
</div>